import React, { useEffect, useState } from 'react';
import logoImg from '../assets/rare-locals-logo.webp';

/**
 * Full-viewport brand intro. Shows once per session, then fades away.
 * Inspired by luxury heritage-brand transitions (e.g. Zino Davidoff).
 */
export default function IntroOverlay() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    // Storage access throws SecurityError on Safari ITP / private mode /
    // cookies-blocked browsers — never let it abort the React mount.
    try {
      return !localStorage.getItem('rl_intro_seen');
    } catch (_) {
      return true; // show intro; worst case it appears once more
    }
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFading(true), 450);
    const t2 = setTimeout(() => {
      setVisible(false);
      try { localStorage.setItem('rl_intro_seen', '1'); } catch (_) {}
    }, 1000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="intro-overlay"
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-brand-dark transition-opacity duration-500 ${fading ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
      style={{ transitionTimingFunction: 'cubic-bezier(.4,.14,.3,1)' }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-brand-dark via-brand-green to-brand-dark" />
      <div className="relative flex flex-col items-center text-center px-6 rl-intro-inner">
        <img
          src={logoImg}
          alt=""
          className="w-28 sm:w-36 md:w-40 h-auto object-contain rl-intro-logo"
        />
        <div className="mt-6 font-serif-brand text-brand-gold text-2xl sm:text-4xl md:text-5xl tracking-[0.18em] rl-intro-title">
          RARE LOCALS
        </div>
        <div className="mt-3 text-brand-gold-light/70 text-[10px] sm:text-xs tracking-[0.4em] uppercase rl-intro-sub">
          Discover Rare — Support Local
        </div>
        <div className="mt-8 h-px w-24 bg-brand-gold/60 rl-intro-line" />
      </div>
    </div>
  );
}
